import "./BlogPostHero.css";
import { useTranslation } from "../../i18n";
import { getOptimizedPublicImage } from "../../utils/imageOptimization";
import blogFallbackAvatar from "../../images/blog-fallback-avatar.png";
import { Link } from "react-router-dom";

function BlogPostHero({ image, backgroundPosition }) {
    const { t } = useTranslation();
    const heroImage = getOptimizedPublicImage(image);
    const heroBackground = heroImage
        ? `url(${heroImage})`
        : `radial-gradient(circle at center, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 48%), linear-gradient(135deg, rgba(63, 89, 76, 0.96) 0%, rgba(151, 183, 158, 0.82) 100%), url(${blogFallbackAvatar})`;
    const heroBackgroundSize = heroImage ? "cover" : "auto, cover, min(24rem, 48vw)";
    const heroBackgroundRepeat = heroImage ? "no-repeat" : "no-repeat, no-repeat, no-repeat";
    const heroBackgroundPosition = heroImage
        ? (backgroundPosition || "center center")
        : "center center, center center, center center";

    return (
        <div 
            className="blogpost-hero" 
            style={{ 
                backgroundImage: heroBackground, 
                backgroundPosition: heroBackgroundPosition,
                backgroundSize: heroBackgroundSize,
                backgroundRepeat: heroBackgroundRepeat
            }}            
        >
            {/* Overlay con más opacidad para mejorar contraste */}
            <div className="overlay-blogs"></div>

            <div className="blogpost-hero-content">
            <h2>{t("blogPost.heroKicker")}</h2>
            <h1>{t("blogPost.heroTitle")}</h1>
            <p>{t("blogPost.heroText")}</p>
                <Link to="/blog" className="blogpost-button">{t("common.readMore")}</Link>
            </div>
        </div>
    );
}

export default BlogPostHero;
